import HelpCenterLayout from "@components/helpCenter/HelpCenterLayout"
import { ResultView, StoreLink } from "@components/helpCenter/ResultParts"
import { useTranslation } from "react-i18next"

export default function RefundGooglePage() {
  const { t } = useTranslation()

  return (
    <HelpCenterLayout>
      <ResultView
        icon="warning"
        title={t("pages.helpCenter.activeGoogleSubscription")}
      >
        <p>{t("pages.helpCenter.refundGoogle.followGoogleInstructions")}</p>

        <StoreLink url="https://support.google.com/googleplay/workflow/9813244" />
      </ResultView>
    </HelpCenterLayout>
  )
}
